import { createFileRoute } from "@tanstack/react-router";
import { DeptContentForm } from "@/components/dept-content/DeptContentForm";
import { FAQS } from "@/lib/deptContent";

function Edit() {
  const { id } = Route.useParams();
  return <DeptContentForm cfg={FAQS} id={id} />;
}

export const Route = createFileRoute("/_app/departments/faqs/$id")({
  component: Edit,
});
